module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/reward-tiers/keys-bcc8e06628b8fdad6dab603666f72929.svg";